<template>
    <component :is="layout">
        <router-view />
    </component>
    <Toast />
</template>

<script lang="ts" setup>
    import { Toast } from 'primevue'
    import { useToast } from 'primevue/usetoast'
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'

    import Blank   from '@/layouts/Blank.vue'
    import Default from '@/layouts/Default.vue'
    import { registerToast } from '@/libs/toast'

    const route = useRoute()

    // Capture the toast service while we are inside an active component setup, so PrintSuccess /
    // PrintError can be invoked from async handlers (where useToast()'s inject() would fail).
    registerToast(useToast())

    const layouts = { Default, Blank }
    const layout  = computed(() => layouts[(route.meta.layout as keyof typeof layouts) ?? 'Default'])
</script>
